<template>
  <div class="container">
    <div class="row">
      <div class="col-12">

        <card>
          <template slot="header">
            <h3 class="card-title text-primary mb-0">Informations légales</h3>
          </template>
          <p class="mb-4">
              Les présentes conditions générales fixent les modalités d’utilisation du
              site web www.peamoni.fr et l’utilisation des services proposés au
              travers du présent site.
              <br>L’utilisateur reconnaît avoir pris connaissance de
              ce document et accepté l’ensemble de ses stipulations. Lorsque l’usage est
              effectué à titre professionnel, l’utilisateur garantit détenir les pouvoirs
              nécessaires pour accepter ces conditions générales au nom de son
              organisation.
          </p>
          <tabs type="primary">
            <tab-pane label="CGU">
              <h4 class="mt-4 mb-1">
                  <strong>Utilisation du site</strong>
              </h4>
              <p>
                  L’éditeur du site met à disposition du contenu sur des données financières
                  et permet aux utilisateurs de suivre une liste d’actions et sa performance
                  dans le temps. <br>Il s’assure en permanence de mettre en œuvre les moyens à sa
                  disposition pour s’assurer de ces contenus. <b>Il doit être rappelé en
                  particulier que les informations dispensées, ne sont pas des conseils.</b> Les
                  informations sont dispensées afin de permettre aux lecteurs de se
                  documenter et de faire mûrir leur analyse avant d’effectuer des opérations
                  financières, mais elles ne peuvent en aucun cas servir de conseils propres
                  à une personne, que seul un professionnel pourrait fournir. <br>L’utilisateur
                  s’engage donc à utiliser ces informations avec l’assistance de son conseil
                  financier et sous son entière responsabilité ; il dégage l’éditeur de toute
                  responsabilité à cet égard, considérant en particulier la gratuité du
                  service. Il est également rappelé que l’usage du site ne crée pas de
                  relations de client avec la société éditrice de ce site, que seule une
                  acceptation expresse et réciproque permet éventuellement de créer.
                  <br>L‘éditeur ne délivre pas de prestations de conseil financier.
              </p>
              <h4 class="mt-4 mb-1">
                  <strong>
                      Responsabilité de l’utilisateur dans l’utilisation du service
                  </strong>
              </h4>
              <p>
                  L’utilisateur s’engage à ne pas perturber le fonctionnement du service
                  offert sur https://www.peamoni.fr, de quelque manière que ce soit. <br>L’usage
                  de tout outil de sécurité (type nmap, nessus, ou autres) ou d’analyse
                  automatisé sur le site ou serveur hébergeant le site est strictement
                  interdit sans autorisation écrite préalable (ex : dans le cadre d’un test
                  d’intrusion commandé spécifiquement par écrit et dûment payé par le
                  responsable du site), de même la licence d’accès au serveur hébergeant
                  Données Personnelles et au site, exclut tout acte de reverse engineering,
                  quel qu’il soit. <br>Ce type d’accès sera donc présumé frauduleux au sens de
                  l’article 323-1 du Code pénal par l’éditeur qui se réserve la possibilité
                  de poursuites. L’utilisateur s’engage également à ne pas perturber l’usage
                  normal des autres utilisateurs du site. <br>En particulier, il s’engage à ne
                  réaliser aucune sollicitation commerciale ou publicitaire sur le site ou
                  sur toute page liée au site le cas échéant (ex : communauté Facebook),
                  quelle que soit leur forme. <br>De même, l’utilisateur s’engage à ne pas opérer
                  de traitements de données personnelles relatifs aux autres utilisateurs du
                  site (ex : collecter leurs noms, prénoms, emails…). Dans tous les cas de
                  non-respect des présentes l’utilisateur s’engage à indemniser l’éditeur de
                  l’intégralité de ses frais engagés (temps passé à gérer la procédure,
                  identification des personnes concernées, frais d’avocat) en cas d’action ou
                  de poursuites. <br>De manière générale, l’utilisateur s’engage à utiliser le
                  service de manière raisonnable (en bon père de famille), et en particulier
                  à s’abstenir de poster des messages illicites, diffamants, insultants ou
                  franchement immoraux sur tout ou partie du site, de même qu’il s’assure du
                  respect des droits des tiers, à ne pas porter atteinte à l’ordre public et
                  aux bonnes mœurs, et au respect de la vie privée. L’utilisateur s’engage
                  également à fournir des données personnelles véridiques, exactes et
                  complètes.
              </p>
            </tab-pane>
            <tab-pane label="CGV">
              <h4 class="mt-4 mb-1">
                <strong>
                    Préambule
                </strong>  
              </h4>
              <p>
                Les présentes conditions générales de vente s'appliquent à toutes les prestations de services conclues sur le site Internet Peamoni
                <br>Le site Internet Peamoni est un service de :
                <ul>
                  <li>la société Vivien Haèse</li>
                  <li>située à : ADDRESS</li>
                  <li>adresse URL du site : https://www.peamoni.fr</li>
                  <li>adresse mail: vivien.haese@gmail.com</li>
                </ul>
                Le client déclare avoir pris connaissance et avoir accepté les conditions générales de vente antérieurement & la passation de la commande. La
                validation de la commande vaut donc acceptation des conditions générales de vente.
              </p>
              <h4 class="mt-4 mb-1">
                <strong>
                    Article 1 - Contenu et champ d'application
                </strong>  
              </h4>
              <p>
                Les présentes conditions générales de vente s'appliquent de plein droit aux prestations de services suivantes
                services de suivi de portefeuilles en ligne
                <br>Elles s'appliquent à l'exclusion de toutes autres conditions, et notamment celles applicables pour les ventes sur internet ou au moyen d'autres
                circuits de distribution et de commercialisation.
                <br>La vente est réputée conclue à la date d'acceptation de la commande ou à l'achat immédiat par le vendeur.
                <br>Toute commande ou achat immédiat implique l'adhésion sans réserve aux présentes conditions générales de vente qui prévalent sur toutes autres
                conditions, à l'exception de celles qui ont été acceptées expressément par le vendeur.
                <br>L'acheteur déclare avoir pris connaissance des présentes conditions générales de vente et les avoir acceptées avant son achat immédiat ou la
                passation de sa commande.
              </p>
              
              <h4 class="mt-4 mb-1">
                <strong>      
                    Article 2-Informations précontractuelles
                </strong>  
              </h4>
              <p>             
                <br>Préalablement à l'achat immédiat ou à la passation de la commande et à la conclusion du contrat, ces conditions générales de vente
                <br>
                Préalablement à l'achat immédiat ou à la passation de la commande et à la conclusion du contrat, ces conditions générales de vente sont
                <br>communiquées à l'acheteur, qui reconnaît les avoir reçues.
                Sont transmises à l'acheteur, de manière claire et compréhensible, les informations suivantes :
                <ul>
                  <li>les caractéristiques essentielles du service ;</li>
                  <li>le prix du service ou le mode de calcul du prix et, s'il y a lieu, tous les frais supplémentaires de transport, de livraison ou d'affranchissement et
                  tous les autres frais éventuels ;</li>
                  <li>la date ou le délai auquel le prestataire s'engage à exécuter le service, quel que soit son prix, et toute autre condition contractuelle :</li>
                  <li>les informations relatives à l'identité du prestataire, à ses coordonnées postales, téléphoniques et électroniques, et à ses activités :</li>
                  <li>les modalités prévues pour le traitement des réclamations ;</li>
                  <li>la durée du contrat, lorsqu'il est conclu à durée déterminée, ou les conditions de sa résiliation en cas de contrat à durée indéterminée ;</li>
                  <li>en ce qui concerne le contenu numérique toute interopérabilité pertinente de ce contenu avec certains matériels ou logiciels dont le professionnel
                  a ou devrait raisonnablement avoir connaissance.</li>
                </ul>
                Le prestataire de services doit également communiquer à l'acheteur, ou mettre à sa disposition, les informations suivantes :
                <ul>
                <li>statut et forme juridique, coordonnées permettant d'entrer en contact rapidement et de communiquer directement avec lui ;</li>
                <li>le cas échéant, le numéro d'inscription au registre du commerce et des sociétés ou au répertoire des métiers ;</li>
                <li>pour les activités soumises à un régime d'autorisation, le nom et l'adresse de l'autorité l'ayant délivrée :
                pour le prestataire assujetti à la taxe sur la valeur ajoutée et identifié par un numéro individuel en application de l'article 286 ter du code général
                des impôts, son numéro individuel d'identification ;</li>
                <li>pour le prestataire membre d'une profession réglementée, son titre professionnel, l'État membre de l'UE dans lequel il a été octroyé ainsi que le
                nom de l'ordre ou de l'organisme professionnel auprès duquel il est inscrit ;</li>
                <li>l'éventuelle garantie financière ou assurance de responsabilité professionnelle souscrite par lui, les coordonnées de l'assureur ou du garant ainsi
                que la couverture géographique du contrat ou de l'engagement.</li>
                </ul>
              </p>

<h4 class="mt-4 mb-1">
                <strong>
                    Article 3 - Commande
                </strong>  
              </h4>
              <p>                
              Par commande, il faut entendre tout ordre portant sur les prestations figurant sur les tarifs du vendeur, et accepté par lui, accompagné du paiement
              de l'acompte éventuellement prévu sur le bon de commande.
              <br>Toute commande, pour être valable, doit être établie sur les bons de commande du vendeur, à la disposition de la clientèle dans ses magasins.
              <br>Toute commande parvenue au vendeur est réputée ferme et définitive.
              <br>Elle entraîne adhésion et acceptation pleine et entière des présentes conditions générales de vente et obligation de paiement des produits
              commandés.
              <br>L'acheteur dispose d'un droit de rétractation de 14 jours à compter de la conclusion du contrat, sauf exception prévue par l'article L.211-28 du
              Code de la consommation.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 4 - Devis   
                </strong>  
              </h4>
              <p>
                Pour les services donnant lieu à l'établissement d'un devis préalable, la vente ne sera considérée comme définitive qu'après établissement d'un
                devis par le prestataire et envoi à l'acheteur de la confirmation de l'acceptation de la commande.
                Les devis établis par le prestataire ont une durée de validité de 15
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 5 - Exécution de la prestation et résolution du contrat
                </strong>  
              </h4>
              <p>
                Sauf conditions particulières expresses propres à la vente, l'exécution de la prestation s'effectuera dans le délai de 2 jours ouvrables à compter
                de la réception par le vendeur d'une commande en bonne et due forme.
                <br>En cas de manquement du vendeur à son obligation d'exécution à la date ou à l'expiration du délai prévu ci-dessus, ou, à défaut, au plus tard 30
                jours après la conclusion du contrat, l'acheteur peut résoudre le contrat, dans les conditions des articles L.216-2 et L. 216-3 et L.216-4 du code de
                la consommation, par lettre recommandée avec demande d'avis de réception ou par un écrit sur un autre support durable, si, après avoir enjoint,
                selon les mêmes modalités, le professionnel de fournir le service dans un délai supplémentaire raisonnable, ce dernier ne s'est pas exécuté dans ce
                délai.
                <br>Le contrat est considéré comme résolu à la réception par le professionnel de la lettre ou de l'écrit l'informant de cette résolution, à moins que le
                professionnel ne se soit exécuté entre-temps.
                <br>
                <br>Néanmoins, l'acheteur peut immédiatement résoudre le contrat lorsque le professionnel refuse de fournir le service ou lorsqu'il n'exécute pas son
                obligation de fourniture du service à la date prévue, si cette date ou ce délai constitue pour l'acheteur une condition essentielle du contrat. Cette
                condition essentielle résulte des circonstances qui entourent la conclusion du contrat ou d'une demande expresse du consommateur avant la
                conclusion du contrat.
                <br>Les frais et les risques liés à cette opération sont à la charge exclusive du prestataire.
                Hormis cas de force majeure, l'acompte versé à la commande est acquis de plein droit et ne peut donner lieu à aucun remboursement
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 6-Exceptions au délai de rétractation
                </strong>  
              </h4>
              <p>                
                Le délai de rétractation de 14 jours ne concerne pas la ou les situations ci-dessous énumérées:
                Annulation de la commande
                <br>En cas d'annulation de la commande par l'acheteur, appès acceptation du vendeur, pour quelque raison que ce soit hormis la force majeure, une
                somme correspondant à 25 % du montant de l'achat sera acquise au vendeur, à titre de dommages et intérêts, en réparation du préjudice ainsi
                subi.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>    
                  Article 7 - Prix
                </strong>  
              </h4>
              <p>                
                Les prix sont fermes et définitifs. Sauf conditions particulières expresses propres à la vente, les prix des prestations effectuées sont ceux figurant
                dans le catalogue des prix au jour de la commande.
                <br>Ils sont exprimés en monnaie légale et stipulés toutes taxes comprises.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>     
                  Article 8 - Paiement
                </strong>  
              </h4>
              <p>
                Sauf autres modalités prévues expressément par les conditions particulières, le paiement du prix s'effectue comptant à la commande. Aucune
                commande ne pourra être prise en compte à défaut d'un complet paiement à cette date.
                <br>Les paiements effectués par l'acheteur ne seront considérés comme définitifs qu'après encaissement effectif des sommes dues par le prestataire.
                <br>Une facture sera remise à l'acheteur sur simple demande.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 9 - Propriété intellectuelle
                </strong>  
              </h4>
              <p>
                Tous les documents techniques, produits, dessins, photographies remis aux acheteurs demeurent la propriété exclusive de Vivien Haèse , seul
                titulaire des droits de propriété intellectuelle sur ces documents, et doivent lui être rendus à sa demande.
                <br>Les acheteurs clients s'engagent à ne faire aucun usage de ces documents, susceptible de porter atteinte aux droits de propriété industrielle ou
                intellectuelle du fournisseur et s'engagent à ne les divulguer à aucun tiers.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 10 - Juridiction compétente
                </strong>  
              </h4>
              <p>
                Tous les litiges auxquels les opérations d'achat et de vente conclues en application des présentes conditions générales de vente pourraient donner
                lieu, concernant tant leur validité, leur interprétation, leur exécution, leur résiliation, leurs conséquences et leurs suites et qui n'auraient pas pu être
                résolus à l'amiable entre le vendeur et le client, seront soumis aux tribunaux compétents dans les conditions de droit commun.
                <br>Pour la définition de la juridiction compétente, le vendeur élit domicile à ADDRESS
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 11 - Langue du contrat   
                </strong>  
              </h4>
              <p>
                  Les présentes conditions générales de vente sont rédigées en langue française. Dans le cas où elles seraient traduites en une ou plusieurs langues
                  étrangères, seul le texte français ferait foi en cas de litige.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 12 - Médiation et règlement des litiges
                </strong>  
              </h4>
              <p>     
                L'acheteur peut recourir à une médiation conventionnelle, notamment auprès de la Commission de la médiation de la consommation ou auprès des
                instances de médiation sectorielles existantes, ou à tout mode alternatif de règlement des différends (conciliation, par exemple) en cas de
                contestation.
                <br>En cas de contestation, les coordonnées du médiateur auquel l'acheteur peut s'adresser sont les suivantes :
                médiateur du e-commerce de la FEVADI :
                <br>
                <br>Conformément à l'article 14 du Règlement (UE) n°524/2013, la Commission Européenne a mis en place une plateforme de Règlement en Ligne
                des Litiges, facilitant le règlement indépendant par voie extrajudiciaire des litiges en ligne entre consommateurs et professionnels de l'Union
                européenne. Cette plateforme est accessible au lien suivant : https://webgate.ec.europa.eu/odr/.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 13 - Loi applicable
                </strong>  
              </h4>
              <p>              
                <br>Les présentes conditions générales sont soumises à l'application du droit français.
                <br>Il en est ainsi pour les règles de fond comme pour les règles de forme. En cas de litige ou de réclamation, l'acheteur s'adressera en priorité au
                vendeur pour obtenir une solution amiable.
              </p>

              <h4 class="mt-4 mb-1">
                <strong>
                  Article 14 - Protection des données personnelles
                </strong>  
              </h4>
              <p>           
                  <b>Données collectées :</b>
                  <br>Les données à caractère personnel qui sont collectées sur ce site sont les suivantes :
                  <ul>
                    <li>ouverture de compte : lors de la création du compte de l'utilisateur, ses adresse électronique; Données de suivi des portefeuilles</li>
                    <li>connexion : lors de la connexion de l'utilisateur au site web, celui-ci enregistre, notamment, ses nom, prénom, données de connexion,
                    d'utilisation, de localisation et ses données relatives au paiement ;</li>
                    <li>profil : l'utilisation des prestations prévues sur le site web permet de renseigner un profil, pouvant comprendre une adresse et un numéro de
                    téléphone ;</li>
                    <li>paiement : dans le cadre du paiement des produits et prestations proposés sur le site web, celui-ci enregistre des données financières relatives au
                    compte bancaire ou à la carte de crédit de l'utilisateur :</li>
                    <li>communication : lorsque le site web est utilisé pour communiquer avec d'autres membres, les données concernant les communications de
                    l'utilisateur font l'objet d'une conservation temporaire ;</li>
                    <li>cookies : les cookies sont utilisés, dans le cadre de l'utilisation du site. L'utilisateur a la possibilité de désactiver les cookies à partir des
                    paramètres de son navigateur.</li>
                  </ul>
                  <br><br>
                  <b>Utilisation des données personnelles</b>
                  Les données personnelles collectées auprès des utilisateurs ont pour objectif la mise à disposition des services du site web, leur amélioration et le
                  maintien d'un environnement sécurisé. Plus précisément, les utilisations sont les suivantes :
                  <ul>
                    <li>accès et utilisation du site web par l'utilisateur ;</li>
                    <li>gestion du fonctionnement et optimisation du site web ;</li>
                    <li>organisation des conditions d'utilisation des Services de paiement ;</li>
                    <li>vérification, identification et authentification des données transmises par l'utilisateur ;</li>
                    <li>proposition à l'utilisateur de la possibilité de communiquer avec d'autres utilisateurs du site web ;</li>
                    <li>mise en ouvre d'une assistance utilisateurs ;</li>
                    <li>personnalisation des services en affichant des publicités en fonction de l'historique de navigation de l'utilisateur, selon ses préférences ;
                    <li>prévention et détection des fraudes, malwares (malicious softwares ou logiciels malveillants) et gestion des incidents de sécurité
                    <li>gestion des éventuels litiges avec les utilisateurs ;</li>
                    <li>envoi d'informations commerciales et publicitaires, en fonction des préférences de l'utilisateur.</li>
                  </ul>

                  <br>
                  <b>Partage des données personnelles avec des tiers</b>
                  <ul>
                    <li>Les données personnelles peuvent être partagées avec des sociétés tierces, dans les cas suivants :</li>
                    <li>quand l'utilisateur utilise les services de paiement, pour la mise en ouvre de ces services, le site web est en relation avec des sociétés bancaires
                    et financières tierces avec lesquelles elle a passé des contrats ;</li>
                    lorsque l'utilisateur publie, dans les zones de commentaires libres du site web, des informations accessibles au public ;
                    <li>quand l'utilisateur autorise le site web d'un tiers à accéder à ses données :</li>
                    <li>quand le site web recourt aux services de prestataires pour fournir l'assistance utilisateurs, la publicité et les services de paiement. Ces
                    prestataires disposent d'un accès limité aux données de l'utilisateur, dans le cadre de l'exécution de ces prestations, et ont une obligation
                    contractuelle de les utiliser en conformité avec les dispositions de la réglementation applicable en matière protection des données à caractère
                    personnel;</li>
                    <li>si la loi l'exige, le site web peut effectuer la transmission de données pour donner suite aux réclamations présentées contre le site web et se
                    conformer aux procédures administratives et judiciaires</li>
                    <li>si le site web est impliquée dans une opération de fusion, acquisition, cession d'actifs ou procédure de redressement judiciaire, elle pourra être
                    amenée à céder ou partager tout ou partie de ses actifs, y compris les données à caractère personnel. Dans ce cas, les utilisateurs seraient informés, avant que les données à caractère personnel ne soient transférées à une tierce partie. </li>
                  </ul>

                  <b>Sécurité et confidentialité</b>
                  <br>Le site web met en ouvre des mesures organisationnelles, techniques, logicielles et physiques en matière de sécurité du numérique pour protéger
                  les données personnelles contre les altérations, destructions et accès non autorisés. Toutefois, il est à signaler qu'internet n'est pas un
                  environnement complètement sécurisé et le site web ne peut pas garantir la sécurité de la transmission ou du stockage des informations sur
                  internet.

                  <br><br><b>Mise en oeuvre des droits des utilisateurs</b>
                  <br>En application de la réglementation applicable aux données à caractère personnel, les utilisateurs disposent des droits ci-dessous mentionnés,
                  qu'ils peuvent exercer en faisant leur demande à Nadresse suivante : vivien.haese@gmail.com
                  <ul>
                    <li>Le droit d'accès : ils peuvent exercer leur droit d'accès, pour connaître les données personnelles les concernant. Dans ce cas, avant la mise
                    en œuvre de ce droit, le site web peut demander une preuve de l'identité de l'utilisateur afin d'en vérifier l'exactitude.</li>
                    <li>Le droit de rectification : si les données à caractère personnel détenues par le site web sont inexactes, ils peuvent demander la mise à jour
                    des informations.</li>
                    <li>Le droit de suppression des données : les utilisateurs peuvent demander la suppression de leurs données à caractère personnel,
                    conformément aux lois applicables en matière de protection des données.</li>
                    <li>Le droit à la limitation du traitement : les utilisateurs peuvent de demander au site web de limiter le traitement des données personnelles
                    conformément aux hypothèses prévues par le RGPD.</li>
                    <li>Le droit de s'opposer au traitement des données : les utilisateurs peuvent s'opposer à ce que ses données soient traitées conformément aux
                    hypothèses prévues par le RGPD.</li>
                    <li>Le droit à la portabilité : ils peuvent réclamer que le site web leur remette les données personnelles qui lui sont fournies pour les
                    transmettre à un nouveau site web.</li>
                  </ul>
                  <br>
                  <br><b>Evolution de la présente clause</b>
                  Le site web se réserve le droit d'apporter toute modification à la présente clause relative à la protection des données à caractère personnel à tout
                  moment. Si une modification est apportée à la présente clause de protection des données à caractère personnel, le site web s'engage à publier la
                  nouvelle version sur son site. Le site web informera également les utilisateurs de la modification par messagerie électronique, dans un délai
                  minimum de 15 jours avant la date d'effet. Si l'utilisateur n'est pas d'accord avec les termes de la nouvelle rédaction de la clause de protection des données à caractère personnel, il a la possibilité de supprimer son compte. 
              </p>

            </tab-pane>

            <tab-pane label="Cookies">
              <h4 class="mt-4 mb-1">
                  <strong>Cookies</strong>
              </h4>
              <p>
                  L’utilisateur est informé que des cookies peuvent s’installer sur son
                  navigateur pour opérer des statistiques agrégées sur l’utilisation du site
                  - étant entendu que ces statistiques sont agrégées et ne permettent pas de
                  suivre le comportement individuel d’une personne. <br>A ce titre, et
                  conformément à la loi précitée, le consentement de l’utilisateur n’est pas
                  demandé car, conformément à l’article 32-II de la loi du 6 janvier 1978,
                  l’accès aux informations stockées dans l’équipement terminal de
                  l’utilisateur ou l’inscription d’informations dans l’équipement terminal de
                  l’utilisateur est strictement nécessaire - d’un point de vue économique - à
                  la fourniture d’un service de communication en ligne à la demande expresse
                  de l’utilisateur. <br>Cette qualification est renforcée par la lecture du
                  projet de règlement e-privacy qui écarte la nécessité de demander le
                  consentement des utilisateurs pour une finalité de mesure d’audience : “si
                  cela est nécessaire pour mesurer des résultats d’audience sur le Web, à
                  condition que ce mesurage soit effectué par le fournisseur du service de la
                  société de l’information demandé par l’utilisateur final.”
                  (https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX%3A52017PC0010).
                  <br>Ces traitements statistiques sont anonymes et agrégés et permettent de
                  déterminer globalement combien de personnes consultent une page web, ou
                  combien de personnes reviennent sur le site. Dans tous les cas
                  l’utilisateur peut librement bloquer l’accès à ces cookies, et les effacer
                  de son navigateur.
              </p>
            </tab-pane>

            <tab-pane label="Données personnelles">
              <h4 class="mt-4 mb-1">
                  <strong>Traitements de données personnelles</strong>
              </h4>
              <p>
                  Certains traitements de données personnelles sont réalisés pour la mise en
                  œuvre opérationnelle de ce site web. L’ensemble de ces traitements est
                  réalisé par l’éditeur du site. <br>Pour chaque traitement, les personnes
                  concernées disposent d’un droit d’interrogation, d’accès, de modification,
                  d’opposition et de rectification sur les données personnelles qui les
                  concernent ; il est possible de demander à ce que ces données soient
                  rectifiées, complétées, clarifiées, mises à jour ou effacées ; la majorité
                  du temps l’utilisateur peut procéder aux modification ou suppression de ses
                  propres données personnelles sans intervention de la part de l’éditeur (par
                  exemple il est possible de supprimer la liste des actions suivies sans
                  intervention de la part de l’éditeur. <br>Vous pouvez nous solliciter également
                  directement pour faire valoir vos droits via Twitter (@moni_app). <br>Les
                  traitements mentionnés ci-dessous ne sont pas forcément des traitements de
                  données personnelles au sens de la loi du 6 janvier 1978 ou au sens du
                  règlement européen (RGPD) ; toutefois, aux fins de transparence nous avons
                  indiqué l’ensemble des traitements mis en place - autant personnels - que
                  traitements anonymes que nous réalisons.
              </p>
              <h4 class="mt-4 mb-1 text-info">
                  <strong>Authentification</strong>
              </h4>
              <table class="table" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vivien Haëse
                              </p>
                              <p>
                                  rgpd@eliomy.fr
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  L’authentification à l’application permet d’accéder aux
                                  contenus et de suivre une liste d’actions cotées en bourse.
                              </p>
                              <p>
                                  Deux modes d’authentification sont disponibles : Gmail et
                                  Twitter.
                              </p>
                              <p>
                                  Les données traitées sont l'email, le nom associé au compte
                                  Gmail, l'adresse IP, le nom d’utilisateur du compte
                                  Twitter, la photo de profil du compte Gmail ou Twitter.
                              </p>
                              <p>
                                  Les données sont utilisées pour authentifier l’utilisateur,
                                  afficher le nom et la photo de profil de l’utilisateur dans
                                  la section « Profil » du site web.
                              </p>
                              <p>
                                  Bien que l’authentification via Twitter demande un accès
                                  complet en lecture seul au compte de l’utilisateur, aucune
                                  récupération des Tweets, abonnés, messages, listes ou
                                  Favoris n’est effectuée.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le site web est techniquement opéré par deux sous-traitans
                                  :
                              </p>
                              <p>
                                  - Github pour l’hébergement des pages web statiques du site
                              </p>
                              <p>
                                  - Firebase / Google Cloud pour l’authentification et le
                                  traitement des données.
                              </p>
                              <p>
                                  Notre sous-traitant - Firebase / Google Cloud – est opéré
                                  sous notre contrôle dans la zone Europe. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) peuvent
                                  être transférées hors Europe sur l'infrastructure technique
                                  de Google Cloud.
                              </p>
                              <p>
                                  Firebase / Google Cloud fournit les clauses standard de
                                  protection adoptées par l'autorité nationale de contrôle et
                                  approuvées par la Commission, conformément à l'article
                                  46.2.d. du règlement. Vous pouvez trouver plus
                                  d'informations au sujet de ces clauses et de la conformité
                                  de Firebase Google Cloud au RGPD à l'url suivante :
                              </p>
                              <p>
                                  <a href="https://firebase.google.com/support/privacy">
                                      https://firebase.google.com/support/privacy
                                  </a>
                              </p>
                              <p>
                                  Les services utilisés par le site web sont :
                                  l’authentification, firestore, Google Analytics
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le temps de l'inscription de l'utilisateur au site web.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de retirer votre consentement à tout
                                  moment sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous devez fournir votre compte Gmail ou votre compte
                                  Twitter pour vous inscrire au site web.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <h4 class="mt-4 mb-1 text-info">
                  <strong>
                      Suivi d’une liste d’actions cotées en bourse ou suivi de portefeuille
                  </strong>
              </h4>
              <table class="table" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vivien Haëse
                              </p>
                              <p>
                                  rgpd@eliomy.fr
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le suivi de portefeuille permet à l’utilisateur de suivre
                                  une liste d’actions cotées en bourse, et l’évolution de son
                                  capital dans le temps
                              </p>
                              <p>
                                  Les données traitées sont le capital initial, les
                                  liquidités disponibles, une liste d’actions en portefeuille
                                  (quantité. Prix d’achat, niveau de stop) et l’historique de
                                  la valeur du portefeuille.
                              </p>
                              <p>
                                  Les données sont utilisées pour afficher des indicateurs de
                                  suivi de performance du portefeuille dans le temps
                                  (historique), de ± values sur les actions et le
                                  portefeuille, et plus généralement, des indicateurs
                                  techniques de suivi.
                              </p>
                              <p>
                                  Une valeur supprimée n’est plus stockée par le site web.
                              </p>
                              <p>
                                  L’historique est calculé tous les soirs à 23h30 avec la
                                  formule suivante :
                              </p>
                              <p>
                                  CAPITAL À J = LIQUIDITE + VALEUR DU CAPITAL INVESTI À J
                              </p>
                              <p>
                                  L’historique conserve 60 jours de données journalière, 1 an
                                  de données hebdomadaire.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le site web est techniquement opéré par deux sous-traitans
                                  :
                              </p>
                              <p>
                                  - Github pour l’hébergement des pages web statiques du site
                              </p>
                              <p>
                                  - Firebase / Google Cloud pour l’authentification et le
                                  traitement des données.
                              </p>
                              <p>
                                  Notre sous-traitant - Firebase / Google Cloud – est opéré
                                  sous notre contrôle dans la zone Europe. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) peuvent
                                  être transférées hors Europe sur l'infrastructure technique
                                  de Google Cloud.
                              </p>
                              <p>
                                  Firebase / Google Cloud fournit les clauses standard de
                                  protection adoptées par l'autorité nationale de contrôle et
                                  approuvées par la Commission, conformément à l'article
                                  46.2.d. du règlement. Vous pouvez trouver plus
                                  d'informations au sujet de ces clauses et de la conformité
                                  de Firebase Google Cloud au RGPD à l'url suivante :
                              </p>
                              <p>
                                  <a href="https://firebase.google.com/support/privacy">
                                      https://firebase.google.com/support/privacy
                                  </a>
                              </p>
                              <p>
                                  Les services utilisés par le site web sont :
                                  l’authentification, firestore, Google Analytics
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Les valeurs suivies sont stockées tant qu’elles sont
                                  présentes dans le portefeuille de l’utilisateur.
                              </p>
                              <p>
                                  L’historique du capital est conservé 1 an. Les données
                                  d’historique supérieures à 1 ans sont supprimées, les
                                  données d’historique inférieures à 1 an sont conservées.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de retirer votre consentement à tout
                                  moment sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous devez fournir la liste une liste d’actions (prix
                                  d’achat, quantité, stop), le capital initial et les
                                  liquidités disponibles pour réaliser le suivi d’un
                                  portefeuille.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <h4 class="mt-4 mb-1 text-info">
                  <strong>
                      Gestion des demandes de droits d’accès et autres droits relatifs au
                      RGPD
                  </strong>
              </h4>
              <table class="table" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vivien Haëse
                              </p>
                              <p>
                                  rgpd@eliomy.fr
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Gestion des demandes de droit d'accès, de modification, de
                                  rectification et autres droits des personnes concernées
                                  issus du règlement européen en matière de protection des
                                  données personnelles entré en vigueur le 25 mai 2018. La
                                  base légale est le respect d'une obligation légale - art.
                                  6.1.c
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le site web est techniquement opéré par deux sous-traitans
                                  :
                              </p>
                              <p>
                                  - Github pour l’hébergement des pages web statiques du site
                              </p>
                              <p>
                                  - Firebase / Google Cloud pour l’authentification et le
                                  traitement des données.
                              </p>
                              <p>
                                  Notre sous-traitant - Firebase / Google Cloud – est opéré
                                  sous notre contrôle dans la zone Europe. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) peuvent
                                  être transférées hors Europe sur l'infrastructure technique
                                  de Google Cloud.
                              </p>
                              <p>
                                  Firebase / Google Cloud fournit les clauses standard de
                                  protection adoptées par l'autorité nationale de contrôle et
                                  approuvées par la Commission, conformément à l'article
                                  46.2.d. du règlement. Vous pouvez trouver plus
                                  d'informations au sujet de ces clauses et de la conformité
                                  de Firebase Google Cloud au RGPD à l'url suivante :
                              </p>
                              <p>
                                  <a href="https://firebase.google.com/support/privacy">
                                      https://firebase.google.com/support/privacy
                                  </a>
                              </p>
                              <p>
                                  Les services utilisés par le site web sont :
                                  l’authentification, firestore, Google Analytics
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le temps de la prescription légale des droits du
                                  responsable du traitement et/ou des personnes concernées
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Il peut être nécessaire de fournir les éléments permettant
                                  d'attester l'identité d'une personne concernée en cas de
                                  demande de droit d'accès relativement à un traitement
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <h4 class="mt-4 mb-1 text-info">
                  <strong>
                      Statistiques de consultation du site (traitement normalement anonyme)
                  </strong>
              </h4>
              <table class="table" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vivien Haëse
                              </p>
                              <p>
                                  hello@eliomy.fr
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Statistiques de consultation du site - le traitement est
                                  normalement entièrement anonyme et aucun moyen n'est mis en
                                  œuvre par le responsable de traitement pour opérer une
                                  quelconque identification des utilisateurs - mais l'adresse
                                  IP des visiteurs peut être traitée pendant quelques
                                  milisecondes - avant anonymisation. La base légale est
                                  l'exécution contractuelle des présentes conditions
                                  d'utilisation du site - art. 6.1.b du RGPD
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le site web est techniquement opéré par deux sous-traitans
                                  :
                              </p>
                              <p>
                                  - Github pour l’hébergement des pages web statiques du site
                              </p>
                              <p>
                                  - Firebase / Google Cloud pour l’authentification et le
                                  traitement des données.
                              </p>
                              <p>
                                  Notre sous-traitant - Firebase / Google Cloud – est opéré
                                  sous notre contrôle dans la zone Europe. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) peuvent
                                  être transférées hors Europe sur l'infrastructure technique
                                  de Google Cloud.
                              </p>
                              <p>
                                  Firebase / Google Cloud fournit les clauses standard de
                                  protection adoptées par l'autorité nationale de contrôle et
                                  approuvées par la Commission, conformément à l'article
                                  46.2.d. du règlement. Vous pouvez trouver plus
                                  d'informations au sujet de ces clauses et de la conformité
                                  de Firebase Google Cloud au RGPD à l'url suivante :
                              </p>
                              <p>
                                  <a href="https://firebase.google.com/support/privacy">
                                      https://firebase.google.com/support/privacy
                                  </a>
                              </p>
                              <p>
                                  Les services utilisés par le site web sont :
                                  l’authentification, firestore, Google Analytics
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Les rares cas ou des données personnelles sont traitées -
                                  le temps nécessaire à leur anonymisation
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le service de statistique est mis en oeuvre sur l'ensemble
                                  de l'infrastructure web.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <h4 class="mt-4 mb-1 text-info">
                  <strong>Supervision d’erreur (traitement normalement anonyme)</strong>
              </h4>
              <table border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vivien Haëse
                              </p>
                              <p>
                                  rgpd@eliomy.fr
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Supervision d’erreur - le traitement est normalement
                                  entièrement anonyme et aucun moyen n'est mis en œuvre par
                                  le responsable de traitement pour opérer une quelconque
                                  identification des utilisateurs - mais l'adresse IP des
                                  visiteurs peut être traitée pendant quelques milisecondes -
                                  avant anonymisation. La base légale est l'exécution
                                  contractuelle des présentes conditions d'utilisation du
                                  site - art. 6.1.b du RGPD
                              </p>
                              <p>
                                  Les erreurs javascript rencontrées par lors de
                                  l’utilisation du site web sont supervisées pour améliorer
                                  le site web.
                              </p>
                              <p>
                                  La supervision d’erreur enregistre le comportement de
                                  l’utilisateur avant la production de l’erreur (le
                                  cheminement de plusieurs clics) afin que l’équipe en charge
                                  du développement puisse reproduire plus facilement les
                                  dysfonctionnements rencontrés par les utilisateurs, et les
                                  corriger.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  La supervision d’erreur est sous-traitée à BugSnag et
                                  opérée sous notre contrôle.
                              </p>
                              <p>
                                  Notre sous-traitant - Bugsnag – est opéré hors Europe, à
                                  San Francisco, Etats-Unis d’Amérique. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) sont
                                  transférées hors Europe sur l'infrastructure technique de
                                  Bugsnag.
                              </p>
                              <p>
                                  Bugsnag fournit les clauses standard de protection adoptées
                                  par l'autorité nationale de contrôle et approuvées par la
                                  Commission, conformément à l'article 46.2.d. du règlement.
                                  Vous pouvez trouver plus d'informations au sujet de ces
                                  clauses et de la conformité de Bugsnag au RGPD à l'url
                                  suivante :
                              </p>
                              <p>
                                  <a href="https://docs.bugsnag.com/legal/privacy-policy/">
                                      https://docs.bugsnag.com/legal/privacy-policy/
                                  </a>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Les rares cas ou des données personnelles sont traitées -
                                  le temps nécessaire à leur anonymisation
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le service de statistique est mis en oeuvre sur l'ensemble
                                  de l'infrastructure web.
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <h4 class="mt-4 mb-1 text-info">
                  <br/>
                  <strong>
                      Détection d’attaques et recourt contentieux contre la fraude
                  </strong>
              </h4>
              <table class="table" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                      <tr>
                          <td width="40%">
                              <p>
                                  <strong>Exigence RGPD</strong>
                              </p>
                          </td>
                          <td width="5%">
                              <p>
                                  <strong>Dispositions</strong>
                              </p>
                          </td>
                          <td width="45%">
                              <p>
                                  <strong>Détail</strong>
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'identité et les coordonnées du responsable du traitement
                                  et, le cas échéant, du représentant du responsable du
                                  traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  l'entreprise A. Erelis ci-dessus
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, les coordonnées du délégué à la protection
                                  des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les finalités du traitement auquel sont destinées les
                                  données à caractère personnel ainsi que la base juridique
                                  du traitement
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Détection d'attaques et recourt contentieux contre des
                                  fraudes. La base légale est l'obligation légale de sécurité
                                  et de protection des données personnelles instituée par le
                                  RGPD (art. 32 et s.) - art. 6.1.c
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point f), les intérêts légitimes poursuivis par le
                                  responsable du traitement ou par un tiers;
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Les destinataires ou les catégories de destinataires des
                                  données à caractère personnel, s'ils existent
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le responsable du traitement, ainsi que toute autorité
                                  légalement autorisée à accéder aux données personnelles en
                                  question
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le cas échéant, le fait que le responsable du traitement a
                                  l'intention d'effectuer un transfert de données à caractère
                                  personnel vers un pays tiers ou à une organisation
                                  internationale, et l'existence ou l'absence d'une décision
                                  d'adéquation rendue par la Commission ou, dans le cas des
                                  transferts visés à l'article 46 ou 47, ou à l'article 49,
                                  paragraphe 1, deuxième alinéa, la référence aux garanties
                                  appropriées ou adaptées et les moyens d'en obtenir une
                                  copie ou l'endroit où elles ont été mises à disposition
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.1.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le site web est techniquement opéré par deux sous-traitans
                                  :
                              </p>
                              <p>
                                  - Github pour l’hébergement des pages web statiques du site
                              </p>
                              <p>
                                  - Firebase / Google Cloud pour l’authentification et le
                                  traitement des données.
                              </p>
                              <p>
                                  Notre sous-traitant - Firebase / Google Cloud – est opéré
                                  sous notre contrôle dans la zone Europe. Certaines données
                                  personnelles (ex : votre email, votre adresse IP) peuvent
                                  être transférées hors Europe sur l'infrastructure technique
                                  de Google Cloud.
                              </p>
                              <p>
                                  Firebase / Google Cloud fournit les clauses standard de
                                  protection adoptées par l'autorité nationale de contrôle et
                                  approuvées par la Commission, conformément à l'article
                                  46.2.d. du règlement. Vous pouvez trouver plus
                                  d'informations au sujet de ces clauses et de la conformité
                                  de Firebase Google Cloud au RGPD à l'url suivante :
                              </p>
                              <p>
                                  <a href="https://firebase.google.com/support/privacy">
                                      https://firebase.google.com/support/privacy
                                  </a>
                              </p>
                              <p>
                                  Les services utilisés par le site web sont :
                                  l’authentification, firestore, Google Analytics
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  La durée de conservation des données à caractère personnel
                                  ou, lorsque ce n'est pas possible, les critères utilisés
                                  pour déterminer cette durée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.a
                              </p>
                          </td>
                          <td>
                              <p>
                                  Le temps de la prescription civile ou pénale
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence du droit de demander au responsable du
                                  traitement l'accès aux données à caractère personnel, la
                                  rectification ou l'effacement de celles-ci, ou une
                                  limitation du traitement relatif à la personne concernée,
                                  ou du droit de s'opposer au traitement et du droit à la
                                  portabilité des données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.b
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit de demander au responsable du traitement
                                  l'accès aux données à caractère personnel, la rectification
                                  ou l'effacement de celles-ci, ou une limitation du
                                  traitement relatif à la personne concernée, ou du droit de
                                  s'opposer au traitement et du droit à la portabilité des
                                  données
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsque le traitement est fondé sur l'article 6, paragraphe
                                  1, point a), ou sur l'article 9, paragraphe 2, point a),
                                  l'existence du droit de retirer son consentement à tout
                                  moment, sans porter atteinte à la licéité du traitement
                                  fondé sur le consentement effectué avant le retrait de
                                  celui-ci
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.c
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Le droit d'introduire une réclamation auprès d'une autorité
                                  de contrôle
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.d
                              </p>
                          </td>
                          <td>
                              <p>
                                  Vous avez le droit d'introduire une réclamation auprès
                                  d'une autorité de contrôle
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Des informations sur la question de savoir si l'exigence de
                                  fourniture de données à caractère personnel a un caractère
                                  réglementaire ou contractuel ou si elle conditionne la
                                  conclusion d'un contrat et si la personne concernée est
                                  tenue de fournir les données à caractère personnel, ainsi
                                  que sur les conséquences éventuelles de la non-fourniture
                                  de ces données
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.e
                              </p>
                          </td>
                          <td>
                              <p>
                                  Ce service imposé en vertu d'une obligation légale
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  L'existence d'une prise de décision automatisée, y compris
                                  un profilage, visée à l'article 22, paragraphes 1 et 4, et,
                                  au moins en pareils cas, des informations utiles concernant
                                  la logique sous-jacente, ainsi que l'importance et les
                                  conséquences prévues de ce traitement pour la personne
                                  concernée
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.2.f
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>
                                  Lorsqu'il a l'intention d'effectuer un traitement ultérieur
                                  des données à caractère personnel pour une finalité autre
                                  que celle pour laquelle les données à caractère personnel
                                  ont été collectées, le responsable du traitement fournit au
                                  préalable à la personne concernée des informations au sujet
                                  de cette autre finalité et toute autre information
                                  pertinente visée au paragraphe 2.
                              </p>
                          </td>
                          <td>
                              <p>
                                  13.3
                              </p>
                          </td>
                          <td>
                              <p>
                                  Non applicable
                              </p>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </tab-pane>

            <tab-pane label="Mentions légales">
              <h4 class="mt-4 mb-1">
                  <strong>Editeur</strong>
              </h4>
              <p>
                Le site est édité par l'entreprise "Eliomy - Vivien Haëse" dont le siège social est 
                situé 15 rue des Halles, 75001 Paris (SIREN : 911 338 770 - Ile-de-France).<br>
                Responsable de publication : Vivien Haëse, Responsable.<br><br>

                <b>Nous contacter: hello@eliomy.fr</b>
                <br><br>

                Les éléments d'identification de l'éditeur sont conservés par le fournisseur du nom de domaine, conformément à la loi. <br>
                <pre>
      OVH
      140, quai du Sartel
      59100 Roubaix
      France
      Téléphone :+33 8 99 70 17 61
      Courrier électronique : tech@ovh.net
                </pre>

              </p>

              <h4 class="mt-4 mb-1">
                  <strong>Propriété</strong>
              </h4>
              <p>
                  Ce site est la propriété exclusive de Eliomy by V. Haëse. 
                  Le site est hébergé par Github. Les données sont traitées
                  par Firebase / Google Cloud - et édité par la société.
              </p>
              <h4 class="mt-4 mb-1">
                  <strong>Propriété des contenus et propriété intellectuelle</strong>
              </h4>
              <p>
                  Toute représentation ou reproduction de contenus, hors cas prévus par la
                  loi (ex: droit de citation), ou aux conditions ci-après définies, sont
                  strictement interdits et constituent une contrefaçon. L’éditeur consent
                  évidemment à l’utilisateur un droit d’usage et d’accès au site à titre
                  gratuit, personnel, non exclusif et non-transférable, en contrepartie de
                  l’acceptation de ces conditions d’utilisation. <br>Dans ce cadre, l’utilisateur
                  a le droit de reproduire le contenu de ce site sur son navigateur afin de
                  consultation immédiate et directe par ses soins (ce qui exclut l’usage de
                  tout robot par exemple programmé pour archiver le site). <br>Ce droit est
                  consenti pour un usage exclusivement personnel et privé. Toute reproduction
                  pour mise à disposition ou rediffusion totale ou partielle de ces contenus,
                  auprès de tiers, sous quelque forme que ce soit est prohibée et constitue
                  une contrefaçon. Les contenus du site ne peuvent être téléchargés,
                  transmis, diffusés, modifiés, copiés, traduits, vendus, loués, exploités,
                  édités, publiés, distribués, modifiés, supprimés, altérés, décompilés,
                  désassemblés, en tout ou partie, sans autorisation préalable et écrite de
                  l’éditeur. <br>Les commentaires postés sur le site, de même que les suggestions
                  d’amélioration du site, ou les informations postées par les utilisateurs,
                  et plus généralement tout contenu collaboratif posté sur le site, sont la
                  propriété des personnes qui les ont laissés. <br>Toutefois en postant un
                  contenu sur le site l’utilisateur cède à l’éditeur à titre gratuit, une
                  licence perpétuelle d’utilisation, de traduction, d’adaptation, d’usage et
                  d’exploitation de ces contenus, pour le monde, afin de diffusion pour toute
                  la durée de validité des droits d’auteur. <br>Dans cette perspective,
                  l’utilisateur est informé que compte tenu du fonctionnement de l’Internet,
                  il ne peut être garanti que ce contenu ne soit pas détourné et ou piraté
                  par d’autres utilisateurs indélicats, et que dans pareille hypothèse, aussi
                  désagréable qu’elle soit, la responsabilité de l’éditeur ne saurait être
                  engagée.
              </p>
              <h4 class="mt-4 mb-1">
                  <strong> Litiges</strong>
              </h4>
              <p>
                  La loi française s’applique au présent contrat.
              </p>
            </tab-pane>
          </tabs>
        </card>
        
        
        
      </div>
    </div>
  </div>
</template>
<script>
import { TabPane, Tabs, } from 'src/components';

export default {
  name: "terms",
  components: {
    TabPane,
    Tabs,
  },
};
</script>
<style></style>
